import React from 'react';
import PropTypes from 'prop-types';
import { CHECKBOX_STATES, EVENT_KEYS } from '../constants';
import getIcon from '../utils/getIcon';
import './FlightCheckbox.scss';


const DEFAULT_CLASS = 'flight-checkbox';

const FlightCheckbox = (props) => {
  const {
    className, disabled, label, checkState,
  } = props;
  const checkIconProps = {
    className: `${DEFAULT_CLASS}__icon`,
  };
  const handleOnSelect = () => {
    const { onSelect } = props;
    if (disabled) return;
    if (onSelect) onSelect();
  };
  const handleOnEnter = (event) => {
    if (event.key === EVENT_KEYS.ENTER) handleOnSelect();
  };

  let wrapperClass = `${DEFAULT_CLASS}-wrapper`;
  wrapperClass += disabled ? ` ${wrapperClass}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let mainClass = DEFAULT_CLASS;
  mainClass += (checkState && checkState !== CHECKBOX_STATES.UNSELECTED
    ? ` ${DEFAULT_CLASS}--${checkState.toLocaleLowerCase()}` : '');
  let icon = null;
  if (checkState === CHECKBOX_STATES.INDETERMINATE) {
    icon = getIcon('indeterminateCheckbox', checkIconProps);
  } else if (checkState === CHECKBOX_STATES.SELECTED) {
    icon = getIcon('checkboxCheck', checkIconProps);
  }

  return (
    <div
      className={wrapperClass}
      onClick={handleOnSelect}
      onKeyPress={handleOnEnter}
      role="checkbox"
      tabIndex="0"
      aria-checked={checkState}
    >
      <span className={`${DEFAULT_CLASS}-label`} tabIndex={disabled ? '-1' : '0'}>{label}</span>
      <div className={mainClass}>
        {icon}
      </div>
    </div>
  );
};

FlightCheckbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checkState: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

FlightCheckbox.defaultProps = {
  className: '',
  label: '',
  disabled: false,
  checkState: CHECKBOX_STATES.UNSELECTED,
};

export default FlightCheckbox;
